import {useDictionary, useItems} from '@adamlip/okeoke.client';
import {Modal, ModalBody, ModalContent, ModalHeader, ModalFooter} from '@heroui/react';
import CouponItem from './CouponItem';
import {useContext, useEffect, useRef, useState} from 'react';
import useBasket from 'hooks/useBasket';
import {CouponContext} from 'contexts/CouponContext';
import {UserContext} from 'contexts/UserContext';
import toast from 'react-hot-toast';
import BarSoftButton from 'components/_NewComponents/BarSoftButton';
import SendVibration from 'utils/Helpers-v1/SendVibration';

export default function OnToOneModal({isOpen, setIsOpen, selectedCoupon, onActivate, setCouponModalOpen}) {
	const {getValue} = useDictionary();
	const {sizes} = useItems();
	const {addItem} = useBasket();

	const {activateCoupon, refreshCoupons} = useContext(UserContext);
	const {setCurrentCoupon} = useContext(CouponContext);

	const [sizeUUIDs, setSizeUUIDs] = useState([]);
	const [reqSizeUUIDs, setReqSizeUUIDs] = useState([]);

	const itemsToAdd = useRef({});
	const reqItemsToAdd = useRef({});

	const handleOk = () => {
		for (let item of Object.values(itemsToAdd.current)) {
			addItem(item);
		}
		for (let item of Object.values(reqItemsToAdd.current)) {
			addItem(item);
		}
		activateCoupon(selectedCoupon?.code, false).then((response) => {
			if (response?.success) {
				toast.success(getValue('app_v2_coupons_activated'));
				SendVibration('success');

				refreshCoupons();
				setCurrentCoupon(response.data);
				if (typeof onActivate === 'function') {
					onActivate();
					setIsOpen(false);
				}
			}
		});
	};

	const onItemChange = (itemUUID, assembledItem) => {
		itemsToAdd.current = {...itemsToAdd.current, [itemUUID]: {...assembledItem}};
	};

	const onReqItemChange = (itemUUID, assembledItem) => {
		reqItemsToAdd.current = {...reqItemsToAdd.current, [itemUUID]: {...assembledItem}};
	};

	useEffect(() => {
		if (selectedCoupon) {
			let itemIDs = [];
			let reqItemIDs = [];
			if (selectedCoupon.items) {
				itemIDs = [...selectedCoupon.items.map((item) => item.okeID)];
			}
			if (selectedCoupon.requireItems) {
				reqItemIDs = [...reqItemIDs, ...selectedCoupon.requireItems.map((item) => item.okeID)];
			}

			setSizeUUIDs(itemIDs);
			setReqSizeUUIDs(reqItemIDs);
		}
	}, [selectedCoupon]);
	useEffect(() => {
		if (isOpen) {
			if (typeof setCouponModalOpen === 'function') {
				setCouponModalOpen(false);
			}
		}
	}, [isOpen]);
	return (
		<Modal
			isOpen={isOpen}
			onOpenChange={() => {
				setIsOpen(!isOpen);
				if (typeof setCouponModalOpen === 'function') {
					setCouponModalOpen(true);
				}
			}}
			size='2xl'
			scrollBehavior='inside'
			classNames={{
				closeButton: 'z-50 bg-primary text-primary-foreground',
			}}>
			<ModalContent>
				{(onClose) => (
					<>
						<ModalHeader className='select-none flex flex-col gap-1'>{selectedCoupon?.name}</ModalHeader>
						<ModalBody>
							<div className='select-none'>
								<div className=''>{getValue('app_v2_coupons_oneToOne_message')}</div>
								<div className='flex gap-2 flex-col'>
									{sizeUUIDs.map((sizeUUID) => {
										const size = sizes?.[sizeUUID];
										const itemUUID = size?.itemUUID;
										return <CouponItem key={sizeUUID} itemUUID={itemUUID} sizeUUID={sizeUUID} onItemChange={onItemChange} />;
									})}
									{reqSizeUUIDs.map((sizeUUID) => {
										const size = sizes?.[sizeUUID];
										const itemUUID = size?.itemUUID;
										return <CouponItem key={sizeUUID} itemUUID={itemUUID} sizeUUID={sizeUUID} onItemChange={onReqItemChange} />;
									})}
								</div>
							</div>
						</ModalBody>
						<ModalFooter className='flex flex-row justify-between'>
							<BarSoftButton isLoading={false} fullWidth={true} color='primary' className='' onPress={() => handleOk()} isDisabled={false}>
								{getValue('app_v2_coupons_oneToOne_ok')}
							</BarSoftButton>
						</ModalFooter>
					</>
				)}
			</ModalContent>
		</Modal>
	);
}
